// extracted by mini-css-extract-plugin
export default {"settings_drawer_container":"bt-slider_settings_drawer_container__2LiNF"};